import React from 'react';

// interface
import { IConfirmModalProps } from '../../../interfaces/interfaces';

function VideoOverlayModal(props: IConfirmModalProps): JSX.Element {
  const { onAbort } = props;
  const onAbortClick = () => {
    // close modal
    onAbort();
  };

  return (
    //  favorutie-list-modal will change
    <div className="modal favourite-list-modal" role="dialog">
      <div className="modal-inner">
        <a role="button" className="modal-closer" onClick={onAbortClick} onKeyDown={onAbortClick} tabIndex={0}>
          <span className="ic-close" />
        </a>

        <div className="modal-inner-content">
          <h3>VideoOverlay Modal</h3>
        </div>
      </div>
    </div>
  );
}
export default VideoOverlayModal;
